import { ticketRoutes } from "./ticket-routes";

export default (router: any) => {
  ticketRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
